import { useState, useCallback } from 'react';
import axios from 'axios';
import notify, { MESSAGES } from '../../../utils/notify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';

const useClosingEvaluationStatus = () => {
  const [isLoading, setIsLoading] = useState(false);

  const closeEvaluation = useCallback(async ({ procurementId, onSuccess }) => {
    if (!procurementId) {
      notify.error(
        'Procurement ID is missing. Refresh the page and try again.'
      );
      return false;
    }

    const token = getAuthToken();
    if (!token) {
      notify.error(MESSAGES.authRequired);
      return false;
    }

    setIsLoading(true);
    try {
      await axios.post(
        `${api.API_URL}/procurement/ClosingEvaluationStatus`,
        { procurementId },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      notify.success('Evaluation locked successfully.');
      onSuccess?.();
      return true;
    } catch (err) {
      notify.apiError(err, 'lock evaluation');
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { closeEvaluation, isLoading };
};

export default useClosingEvaluationStatus;
